<template>
  <div>
    <data-grid
      url="users"
      :columns="columns"
      :title="title"
      :actions="actions"
      :onRowClicked="onRowClicked"
      ref="grid"
      navigationPath="onRowClicked"
      navigationField="onRowClicked"
    ></data-grid>
    <v-dialog v-model="deleteUserConfirmationDialog" max-width="500">
      <v-card class="pa-2">
        <v-card-title class="headline text-danger">Are You Sure?</v-card-title>
        <v-card-text
          >This will delete User:
          <div class="font-weight-medium">
            {{ userClicked.userName }}
          </div></v-card-text
        >
        <v-card-actions>
          <div class="text-xs-right">
            <v-spacer></v-spacer>
            <v-btn
              color="default"
              dark
              @click="deleteUserConfirmationDialog = false"
              >Cancel</v-btn
            >
            <v-btn color="success" :loading="deletingUser" @click="deleteUser"
              >Delete</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="updateUserDialog" max-width="500">
      <v-card class="pa-2">
        <v-card-title class="headline">User</v-card-title>
        <v-card-text class="mb-0 pb-0">
          <v-layout row class="mb-2">
            <div class="font-weight-medium mr-2">
              User Name:
            </div>
            <div>
              {{ userClicked.userName }}
            </div>
            <v-spacer></v-spacer>
            <v-btn
              @click="resetPassword()"
              v-if="!showResetPasswordSection && !userClicked.isWindowsUser"
              class="mt-0"
              color="success"
              small
              outline
              >Reset Password</v-btn
            >
            <v-btn
              @click="showResetPasswordSection = false"
              v-if="showResetPasswordSection"
              class="mt-0"
              color="success"
              small
              outline
              >Cancel Reset Password</v-btn
            >
          </v-layout>
        </v-card-text>

        <v-text-field
          v-if="showResetPasswordSection"
          class="mx-3"
          label="New Password"
          v-model="newPassword"
          ref="newPassword"
          type="password"
          :rules="[rules.required]"
        ></v-text-field>

        <v-text-field
          class="mx-3"
          label="Uta Phone"
          v-model="userClicked.utaPhone"
          ref="utaPhone"
          :rules="[rules.phone]"
        ></v-text-field>
        <v-select
          class="mx-3"
          :items="branches"
          hide-details
          multiple
          label="Branch"
          v-model="userClicked.selectedBranches"
        ></v-select>
        <v-card-actions>
          <v-layout column>
            <v-select
              class="mb-5"
              hide-details
              multiple
              label="Role"
              chips
              item-text="name"
              v-model="userClicked.roles"
              :items="roles"
            ></v-select>

            <div class="text-xs-right">
              <v-spacer></v-spacer>
              <v-btn
                color="default"
                dark
                @click="
                  updateUserDialog = false;
                  showResetPasswordSection = false;
                "
                >Cancel</v-btn
              >
              <v-btn
                color="warning"
                dark
                :loading="deletingUser"
                @click="deleteUserConfirmationDialog = true"
                >Delete</v-btn
              >
              <v-btn
                :disabled="deletingUser"
                :loading="processing"
                color="success"
                @click="updateUser"
              >
                save
              </v-btn>
            </div></v-layout
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    title: "Users",
    columns: [
      {
        sortable: true,
        label: "User Name",
        field: "userName",
        hidden: false,
        filterOptions: {
          enabled: true,
        },
      },
      {
        sortable: true,
        label: "Email",
        field: "email",
        hidden: false,
        filterOptions: {
          enabled: true,
        },
      },
      {
        sortable: true,
        label: "Roles",
        field: "roleNames",
        hidden: false,
        filterOptions: {
          enabled: true,
        },
      },
      {
        sortable: true,
        label: "Branch",
        field: "branch",
        hidden: false,
        filterOptions: {
          enabled: true,
        },
      },
      {
        sortable: true,
        label: "Windows User",
        field: "isWindowsUser",
        width: "220px",
        type: "boolean",
        hidden: false,
        filterOptions: {
          enabled: true,
        },
      },
    ],
    actions: [
      {
        text: "Add User",
        link: "AddUser",
      },
    ],

    updateUserDialog: false,
    userClicked: {},
    processing: false,
    deletingUser: false,
    deleteUserConfirmationDialog: false,
    branches: [],

    roles: [],

    showResetPasswordSection: false,
    resetPasswordToken: "",
    newPassword: "",

    rules: {
      required: (value) => !!value || "Required.",
      phone: (v) => {
        return (
          !(v ? v.trim() : v) ||
          ([10, 11].includes(v.replace(/-/g, "").length) &&
            /^\d+$/.test(v.replace(/-/g, ""))) ||
          "A Valid Phone Number Is Required."
        );
      },
    },
  }),
  created() {
    this.loadRoles();
    this.loadBranchList();

    const importUsersAction = {
      text: "Import Users",
      name: "ImportUsers",
      loading: false,
    };

    importUsersAction.action = () =>
      this.importUsers(importUsersAction.loading);

    this.actions.push(importUsersAction);
  },
  methods: {
    async loadRoles() {
      const response = await this.$http.get("odata/roles");

      this.roles = response.value.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    },
    async onRowClicked(user) {
      this.userClicked = user;

      this.userClicked.roles = await this.$http.get(
        "api/login/GetUserRoles?userName=" + user.userName
      );

      this.userClicked.selectedBranches = this.userClicked.branch
        ? this.userClicked.branch.split(",")
        : [];

      this.showResetPasswordSection = false;
      this.updateUserDialog = true;
    },
    async loadBranchList() {
      const branches = await this.$http.get("api/students/getBranchList?");

      branches.push("BUS");
      branches.push("ALL");

      this.branches = branches.filter(Boolean).sort();
    },
    async resetPassword() {
      // const token = await this.$http.get(
      //     "api/login/getResetToken?userId=" + this.userClicked.id
      // );

      // this.resetPasswordToken = token[0];

      this.newPassword = "";
      this.showResetPasswordSection = true;
    },
    async importUsers() {
      try {
        await this.$http.post("api/login/importAdUsers");

        this.$notify({
          group: "notification",
          text: "Users List Updated",
          type: "success",
        });

        this.$refs.grid.load();
      } catch (e) {}
    },
    async saveNewPassword() {
      if (!this.$refs.newPassword.validate(true)) return false;

      this.processing = true;

      try {
        await this.$http.post("api/login/resetPassword", {
          userId: this.userClicked.id,
          //token: this.resetPasswordToken,
          newPassword: this.newPassword,
        });

        this.newPassword = "";

        return true;
      } catch (e) {
        this.processing = false;

        return false;
      }
    },
    async deleteUser() {
      this.deletingUser = true;

      try {
        await this.$http.post(
          "api/login/DeleteUser?userId=" + this.userClicked.id
        );

        this.$refs.grid.load();

        this.deleteUserConfirmationDialog = false;
        this.updateUserDialog = false;
      } catch (e) {
      } finally {
        this.deletingUser = false;
      }
    },
    async updateUser() {
      if (this.showResetPasswordSection) {
        const saved = await this.saveNewPassword();

        if (!saved) return;
      }

      this.processing = true;

      try {
        await this.$http.post("api/login/UpdateUser", {
          username: this.userClicked.userName,
          branch: this.userClicked.selectedBranches.join(","),
          roles: this.userClicked.roles,
          utaPhone: this.userClicked.utaPhone ? this.userClicked.utaPhone : "",
        });

        this.$refs.grid.load();
        this.updateUserDialog = false;
      } catch (e) {
      } finally {
        this.processing = false;
      }
    },
  },
};
</script>
<style></style>
